// hook/useProductSearch.js
import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getCategoryList } from "../redux/reduxApi/admin/CategoryReduxApi";

const useProductSearch = (options = {}) => {
  const { 
    pageSize = 30,
    searchField = "name"
  } = options;

  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);

  // Format category options (only subcategories)
  const formatProductOptions = useCallback((categories) => {
    // Filter only subcategories (parentCategoryId !== null)
    const subcategories = categories.filter(
      (item) => item.parentCategoryId !== null
    );
    
    return subcategories.map((category) => ({
      label: category.name,
      value: category.name
    }));
  }, []);
  const loadProducts = useCallback(async (search, loadedOptions, { page = 1 }) => {
    const searchCriteria = [];

    // Build search criteria based on search term
    if (search && search.trim()) {
      searchCriteria.push({
        field: searchField,
        operation: "contains",
        value: search.trim()
      });
    }

    try {
      const response = await dispatch(getCategoryList({
        page: page,
        size: pageSize,
        search: searchCriteria
      }));

      const categories = response.payload?.data || [];
      const total = response.payload?.data?.total || 0;
      
      setTotalCount(total);
      
      const options = formatProductOptions(categories);
      
      return {
        options: options,
        hasMore: categories.length === pageSize,
        additional: {
          page: page + 1
        }
      };
    } catch (error) {
      console.error("Error loading products:", error);
      return {
        options: [],
        hasMore: false,
        additional: { page }
      };
    }
  }, [dispatch, pageSize, searchField, formatProductOptions]);

 

  return {
    loadProducts,
    totalCount,
  };
};

export default useProductSearch;